import { Observable, of, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { CommunicationConfigService, ConfigService } from '@argalis-apps/angular-global';
import { MFormation, MModalite } from '@argalis-apps/models';
import * as TESTDATA from './TESTDATA';
@Injectable({
  providedIn: 'root'
})
export class FormationService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  private emitChangeSource = new Subject<string>();
  public changeEmitted$ = this.emitChangeSource.asObservable();

  getFormModaliteList(formId, isParcours = false): Observable<MFormation.IModaliteInfo[]> {
    if (this.configService.getOptions().userTestData) {
      return of([{ libelle: 'Présentiel', id: 1 }, { libelle: 'Blended', id: 2 }, { libelle: 'E-learning', id: 3 }]);
    } else {
      const params = { isParcours: `${isParcours}` };
      return this.http.get<MFormation.IModaliteInfo[]>(
        `${this.communicationConfigService.getApiUri()}/formation/produit/${formId}/modalite`,
        {
          params
        }
      );
    }
  }

  get(formId = 0, moda = 0, isParcours = false, postal = ''): Observable<MFormation.IFormInfo> {
    if (this.configService.getOptions().useTestData) {
      return of(TESTDATA.TESTDATA);
    } else {
      const params = { isParcours: `${isParcours}`, postal: postal };
      return this.http.get<MFormation.IFormInfo>(
        `${this.communicationConfigService.getApiUri()}/formation/produit/${formId}/${this.tranfModaToId(
          moda
        )}/session`,
        {
          params
        }
      );
    }
  }

  private tranfModaToId(moda: number): MFormation.EModa {
    switch (Number(moda)) {
      case 1:
        return MFormation.EModa.Presentiel;
        break;
      case 2:
        return MFormation.EModa.Blended;
        break;
      case 3:
        return MFormation.EModa.Elearning;
        break;
      default:
        return MFormation.EModa.Presentiel;
    }
  }

  getDocument(formId = 0, moda = 0, isParcours = false): Observable<any> {
    const params = { isParcours: `${isParcours}` };
    return this.http.get<any>(`${this.communicationConfigService.getApiUri()}/formation/document/${formId}/${moda}`, {
      params
    });
  }

  getDomain(formId = 0) {
    return this.http.get<any>(`${this.communicationConfigService.getApiUri()}/formation/produit/${formId}/domain`);
  }
}
